import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';

function buildUrl(base, params) {
  let url = base;
  if (params) {
    const queryParams = Object.keys(params)
      .map(key => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');
    url += `?${queryParams}`;
  }
  return url;
}

function postPageTracking({ params, body }) {
  const url = buildUrl(ApiUrl.TRACKINGSERVICE + 'page/', params);
  return httpService.post(url, body).catch(() => {
    return { data: null };
  });
}

function postItemTracking({ params, body }) {
  const url = buildUrl(ApiUrl.TRACKINGSERVICE + 'item/', params);
  return httpService.post(url, body).catch(() => {
    return { data: null };
  });
}

const obj = { postPageTracking, postItemTracking };

export default obj;
